// Cetus CLMM graduation: create the SUI/<token> pool seeded with ALL migrated tokens
// and the collected SUI, then PERMANENTLY LOCK the LP via Cetus LP-Burn and hand the
// burn PROOF to the token CREATOR (dev) so liquidity can never be pulled yet the dev can
// still claim pool trading fees — all in one wallet-signed transaction. Signed by the
// migrator wallet (which holds the graduated liquidity after launchpad::migrate).
const BACKEND = process.env.REACT_APP_BACKEND_URL;
const RPC = `${BACKEND}/api/sui-grpc`; // Cetus SDK talks Sui gRPC-web
const SUI = "0x2::sui::SUI";
const BURN_ADDR = "0x0000000000000000000000000000000000000000000000000000000000000000";
const TICK_SPACING = 200; // 1% fee tier — allowed for SUI pairs on Cetus mainnet
const CHAIN = "sui:mainnet";

// amounts are the graduated liquidity now sitting in the migrator wallet.
// gradPrice = final bonding-curve price (SUI/token); seeding at this price keeps the
// Cetus opening price identical to the graduation price (no discontinuity).
export async function graduateToCetus(signExec, { sender, creator, coinType, coinDecimals, gradPrice, suiMist }) {
  const { CetusClmmSDK } = await import("@cetusprotocol/sui-clmm-sdk");
  const { CetusBurnSDK } = await import("@cetusprotocol/burn-sdk");

  const clmm = CetusClmmSDK.createSDK({ env: "mainnet", full_rpc_url: RPC });
  clmm.setSenderAddress(sender);
  const burn = CetusBurnSDK.createSDK({ env: "mainnet", full_rpc_url: RPC });
  burn.setSenderAddress(sender);

  // Seed the pool at the graduation price (virtual+real)/reserve = the displayed curve price
  // so the market cap does not drop. Fix all raised SUI; SDK computes the matching coins.
  const calc = await clmm.Pool.calculateCreatePoolWithPrice({
    tick_spacing: TICK_SPACING,
    current_price: String(gradPrice),
    coin_amount: String(suiMist),
    fix_amount_a: false,
    slippage: 0.02,
    coin_decimals_a: coinDecimals,
    coin_decimals_b: 9,
    price_base_coin: "coin_a",
    add_mode_params: { is_full_range: true },
  });

  const result = await clmm.Pool.createPoolWithPriceReturnPositionPayload({
    tick_spacing: TICK_SPACING,
    uri: "",
    calculate_result: calc,
    add_mode_params: { is_full_range: true },
    coin_type_a: coinType,
    coin_type_b: SUI,
  });

  const tx = result.tx;
  const proof = burn.Burn.createBurnLPV2Payload(result.pos_id, tx);
  tx.transferObjects([proof], tx.pure.address(creator));
  tx.transferObjects([result.remain_coin_a], tx.pure.address(BURN_ADDR));
  tx.transferObjects([result.remain_coin_b], tx.pure.address(sender));

  const res = await signExec({ transaction: tx, chain: CHAIN });
  return res.digest;
}
